import { useEffect } from "react";
import { Alert } from "@theorgchartdev/storybook";

const getToastDuration = message => {
  const baseTime = 3000; // Base duration of 3 seconds
  const timePerChar = 50; // 50ms per character
  return Math.max(Math.min(baseTime + message.length * timePerChar, 8000), baseTime);
};

export const Toast = ({ id, message, content, status, onRemove, alertProps, timeoutMS }) => {
  const displayContent = content || message;
  const showDuration = timeoutMS ?? getToastDuration(message || "");
  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(id);
    }, showDuration);

    return () => clearTimeout(timer);
  }, [id, onRemove, showDuration]);

  return (
    <Alert
      severity={status}
      alertActions={{ closeAction: onRemove }}
      withBorder
      withShadow
      {...alertProps}
    >
      {displayContent}
    </Alert>
  );
};
